import { createSelector } from '@reduxjs/toolkit';

import { AgentAuthState, name } from '../reducers/agentAuth';

export const getAgentAuthSlice = (state): AgentAuthState => state[name];

export const agentSessionSelector = createSelector(
  [getAgentAuthSlice],
  ({ session }) => session
);

export const agentPapiTokenSelector = createSelector(
  [agentSessionSelector],
  (session) => session?.papi_token || null
);
